import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import DropdownConfirmButtonPanel from '../DropdownConfirmButtonPanel';
import MultiSelector from '../MultiSelector';
export default function MultiSelectDropdown(context, _ref) {
  var onClear = _ref.onClear,
      showConfirm = _ref.showConfirm,
      showClear = _ref.showClear,
      onCloseAll = _ref.onCloseAll,
      selected = _ref.value,
      setOpen = _ref.setOpen,
      onClose = _ref.onClose,
      maxLength = _ref.maxLength,
      showLength = _ref.showLength,
      tagRender = _ref.tagRender,
      valueName = _ref.valueName,
      maxShowLength = _ref.maxShowLength,
      disableEmpty = _ref.disableEmpty,
      allOptionLabel = _ref.allOptionLabel,
      renderMessageProps = _ref.renderMessageProps,
      isOptionDisabled = _ref.isOptionDisabled,
      disableAll = _ref.disableAll,
      allOptionSelected = _ref.allOptionSelected;
  var selectedLength = selected.length;
  var overflow = maxLength != null && selectedLength > maxLength && !allOptionSelected; // 选项溢出

  var empty = selectedLength === 0; // 长度为空

  var confirmDisabled = overflow || empty && !allOptionSelected && disableEmpty;
  return _objectSpread({
    renderMessageProps: _objectSpread(_objectSpread({}, renderMessageProps), {}, {
      overflow: overflow,
      empty: empty
    }),
    disableClose: !showConfirm && confirmDisabled,
    selector: {
      Component: MultiSelector,
      props: {
        isOptionDisabled: isOptionDisabled,
        onCloseAll: onCloseAll,
        value: selected,
        setOpen: setOpen,
        onClose: onClose,
        maxLength: maxLength,
        showLength: showLength,
        tagRender: tagRender,
        valueName: valueName,
        maxShowLength: maxShowLength,
        allOptionLabel: allOptionLabel,
        disableAll: disableAll,
        allOptionSelected: allOptionSelected // 有全选对应的值并且处于全选状态

      }
    }
  }, DropdownConfirmButtonPanel(_objectSpread(_objectSpread({}, context), {}, {
    showClear: showClear,
    empty: [],
    showConfirm: showConfirm,
    confirmDisabled: confirmDisabled,
    onClear: onClear
  })));
}